import React from "react";
import { useTranslation } from "react-i18next";
import "./numerousProcesses.scss";

function NumerousProcesses() {

  const { t } = useTranslation()

  return (
    <div className="container-numerous-processes">
      <div className="texts-numerous-processes">
        <h1>{t("retail.numerous_processes.title")}</h1>
        <p>{t("retail.numerous_processes.section_text_1")}</p>
        <p>{t("retail.numerous_processes.section_text_2")}</p>
      </div>
    </div>
  );
}

export default NumerousProcesses;
